export class RatingApiModel {
  cinemaGroupId: string;

  symbol: string;

  value: string;

  description: string;
}
